import { CreateStoreOptions, createStore } from './create-store';
import {
  pageChangeMiddleware,
  receiveViewportLocationChangeMiddleware,
  sendLocationChangeToViewport,
} from '../middleware';
import { AdminAppAction } from '../actions';
import { AdminAppState } from '../state';
import { Store } from 'redux';
import { adminRootEpic } from '../epics';
import { createAdminAppReducer } from '../reducers';

/**
 * Create admin app store options object.
 */
export type CreateAdminAppStoreOptions = Omit<
  CreateStoreOptions<AdminAppState, AdminAppAction>,
  'rootReducer' | 'name'
>;

/**
 * Creates a new Admin App Redux store for the client side.
 * @param options Create store options object.
 */
export const createAdminAppStore = (
  options: CreateAdminAppStoreOptions,
): Store<AdminAppState, AdminAppAction> => {
  const rootReducer = createAdminAppReducer({ history: options.history });

  const [store, epicMiddleware] = createStore({
    ...options,
    rootReducer,
    middleware: [
      sendLocationChangeToViewport(),
      receiveViewportLocationChangeMiddleware(),
      pageChangeMiddleware(),
    ],
    name: 'Admin App',
  });

  epicMiddleware.run(adminRootEpic);

  return store;
};
